<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table :headers="headers" :items="items" class="elevation-1" :loading="loading">
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.clmNo }}</td>
                <td>{{ row.item.lossDate }}</td>
                <td>{{ formatDisplayNumber(row.item.paidAnmt) }}</td>
                <td>{{ formatDisplayNumber(row.item.planPayt) }}</td>
                <td>{{ formatDisplayNumber(row.item.totRes) }}</td>
                <td>{{ formatDisplayNumber(row.item.netRes) }}</td>
                <td>{{ formatDisplayNumber(row.item.rcvyAmtResCurr) }}</td>
                <td>{{ row.item.clmStat }}</td>
                <td style="text-align: center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" color="primary" text @click="viewClaimHeader(row.item)" :loading="loading">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ labels.query }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        query: 'Query'
      },
      headers: [
        { text: 'Claim No.', align: 'left', value: 'clmNo' },
        { text: 'Loss Date', value: 'lossDate' },
        { text: 'Paid Amount', value: 'paidAnmt' },
        { text: 'Planned Payment', value: 'planPayt' },
        { text: 'Total Incurred Claim', value: 'totRes' },
        { text: 'Net Reserve', value: 'netRes' },
        { text: 'Recovery Amount', value: 'rcvyAmtResCurr' },
        { text: 'Status', value: 'clmStat' },
        { text: 'Actions', value: 'action', align: 'right' }
      ],
      itemList: [],
      loading: false
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    policyQuery() {
      return this.$store.state.underwriting.policyQuerySettings
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('policyQueryInit')])
      if (this.policyQuery.init === 1) {
        // await this.$store.dispatch('claimsInit')
        // await this.$store.dispatch('claimsListingInit')
        await this.getClaimsInformation()
      }
    },
    async getClaimsInformation() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.claimsInformation
      if (apiUrl) {
        try {
          this.loading = true
          const expand = { polNo: this.polMaster.polNo }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            while (this.items.length > 0) {
              this.items.pop()
            }
            this.itemList = []
            data.clmMasterList.map((item) => {
              const convertItem = {
                clmNo: item.clmNo,
                lossDate: formatDisplayDate(item.lossDate),
                paidAnmt: item.paidAnmt === null ? 0 : item.paidAnmt,
                planPayt: item.planPayt === null ? 0 : item.planPayt,
                totRes: item.totRes === null ? 0 : item.totRes,
                netRes: item.netRes === null ? 0 : item.netRes,
                rcvyAmtResCurr: item.rcvyAmtResCurr === null ? 0 : item.rcvyAmtResCurr,
                clmStat: item.clmStat
              }
              this.items.push(convertItem)
            })
            this.loading = false
          } else {
            this.itemList = []
            this.loading = false
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async viewClaimHeader(data) {
      try {
        this.loading = true
        const dispatchObj = {
          clmNo: data.clmNo,
          query: false
        }
        const loadBack = {
          action: 'FromPolicy'
        }
        // await this.$store.dispatch('claimsInit')
        await this.$store.dispatch('claimEntryInit')
        await this.$store.dispatch('loadClaim', dispatchObj)
        await this.$store.dispatch('loadBack', loadBack)
        this.$router.push({ name: 'qClaimHeader', params: { claimNo: data.clmNo, clmNo: data.clmNo } })
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
        this.loading = false
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style>
</style>
